// extracted by mini-css-extract-plugin
export default {"lang-select":"LangSelect_lang-select__rk9rd","lang-element":"LangSelect_lang-element__JFb8R"};